import {
	TundishAlarmConfiguration,
	tundishesRepository,
} from "@/repositories/tundishes/tundishes.repository";
import {
	Button,
	Checkbox,
	FormControlLabel,
	Grid,
	Paper,
	TextField,
	Typography,
} from "@material-ui/core";
import { useEffect, useState } from "react";

const TundishAlarmsPage = () => {
	const [config, setConfig] = useState<TundishAlarmConfiguration | null>(null);
	const [isSaving, setIsSaving] = useState(false);
	const [message, setMessage] = useState<string | null>(null);

	useEffect(() => {
		(async () => {
			setConfig(await tundishesRepository.getAlarmConfiguration());
		})();
	}, []);

	const updateField = (field: keyof TundishAlarmConfiguration, value: any) => {
		setConfig((current) =>
			current ? { ...current, [field]: value } : current,
		);
	};

	const save = async () => {
		if (!config) return;
		setIsSaving(true);
		setMessage(null);
		try {
			const updated = await tundishesRepository.updateAlarmConfiguration({
				triggerAfterDays: Number(config.triggerAfterDays),
				expiresAfterDays: Number(config.expiresAfterDays),
				repeatPopupAfterHours: Number(config.repeatPopupAfterHours),
				operatorRequired: config.operatorRequired,
				commentsEnabled: config.commentsEnabled,
			});
			setConfig(updated);
			setMessage("Saved");
		} catch (e: any) {
			setMessage(e?.response?.data?.detail ?? e.toString());
		} finally {
			setIsSaving(false);
		}
	};

	if (!config) {
		return <Typography>Loading tundish alarm configuration...</Typography>;
	}

	return (
		<Paper style={{ padding: 20, maxWidth: 720 }}>
			<Grid container spacing={2} direction="column">
				<Grid item>
					<Typography variant="h5">Tundish Alarms</Typography>
					<Typography variant="subtitle1">{config.alarmName}</Typography>
				</Grid>
				<Grid item>
					<TextField
						label="Trigger after days"
						type="number"
						value={config.triggerAfterDays}
						onChange={(event) =>
							updateField("triggerAfterDays", event.target.value)
						}
						fullWidth
						variant="outlined"
					/>
				</Grid>
				<Grid item>
					<TextField
						label="Expires after days"
						type="number"
						value={config.expiresAfterDays}
						onChange={(event) =>
							updateField("expiresAfterDays", event.target.value)
						}
						fullWidth
						variant="outlined"
					/>
				</Grid>
				<Grid item>
					<TextField
						label="Repeat popup after hours"
						type="number"
						value={config.repeatPopupAfterHours}
						onChange={(event) =>
							updateField("repeatPopupAfterHours", event.target.value)
						}
						fullWidth
						variant="outlined"
					/>
				</Grid>
				<Grid item>
					<FormControlLabel
						control={
							<Checkbox
								checked={config.operatorRequired}
								onChange={(event) =>
									updateField("operatorRequired", event.target.checked)
								}
							/>
						}
						label="Operator required"
					/>
				</Grid>
				<Grid item>
					<FormControlLabel
						control={
							<Checkbox
								checked={config.commentsEnabled}
								onChange={(event) =>
									updateField("commentsEnabled", event.target.checked)
								}
							/>
						}
						label="Allow comments"
					/>
				</Grid>
				<Grid item>
					<Button
						color="primary"
						variant="contained"
						onClick={save}
						disabled={isSaving}
					>
						Save
					</Button>
					{message && (
						<Typography style={{ marginTop: 10 }}>{message}</Typography>
					)}
				</Grid>
			</Grid>
		</Paper>
	);
};

export default TundishAlarmsPage;
